export default {
  settings_title: "Configuración",
  settings_description: "Ver el",
  settings_missing_inspection_rules_report: "informe de reglas de inspección faltantes",
  settings_create_edit_rules: "para crear y editar nuevas reglas para tus activos.",
  settings_saved: "Configuración guardada exitosamente",
  settings_default_asset_type: "Tipo de activo predeterminado para EVIR Mobile",
  settings_default_asset_type_desc: "Elige qué tipo de activo debe ser el predeterminado para todas las inspecciones futuras.",
  settings_inspection_image_retention: "Retención de inspección e imagen",
  settings_retention_desc: "Período de tiempo que se conservarán las inspecciones e imágenes en el archivo.",
  settings_retain_for_number_of_years: "Retener por número de años",
  settings_save: "Guardar Configuración",
  settings_undo: "Deshacer",
  settings_saving: "Guardando...",
};
